import React from 'react';
import { Lang, DATA_KEYS } from 'shared/constants';
import { ContentList } from '../../../components/content';
import styles from './Home.module.scss';
const { KNOWLEDGE_BASE } = DATA_KEYS;

const HomePageComponent = React.memo(
  ({ lang, getKnowledgeContent, list, lastUpdated, isReady, fullPath, id }) => {
    const [isRefreshing] = React.useState(false);

    const loadData = async (isInit = false) => {
      await getKnowledgeContent();
    };

    return (
      <div className={styles.root} data-key={KNOWLEDGE_BASE.LIST}>
        <ContentList
          isRefreshing={isRefreshing}
          refresh={loadData}
          isReady={isReady}
          list={list}
          id={id}
          fullPath={id}
        />
      </div>
    );
  },
);

HomePageComponent.defaultProps = {
  lang: Lang.HOME_SCREEN,
  list: null,
  isReady: false,
  fullPath: null,
  id: null,
};

export { HomePageComponent };
